import types from "./types";
import service from "./service";
import swal from "sweetalert";
import { utils } from "~/utils";

const getAll = (format_result = false) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_All });
        service
            .getAll(getState().cpo.pagination.actualPage, getState().cpo.filters, format_result)
            .then(result => {
                const { pagination, list, fields } = result;
                dispatch(getAllSuccess({ list, fields }));
                dispatch(updatePagination(pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const getCpoItems = cpoID => {
    return dispatch => {
        dispatch({ type: types.GET_CPO_ITEMS });
        service
            .getItems(cpoID)
            .then(cpo => {
                dispatch({ type: types.GET_CPO_HISTORY });
                service
                    .getHistory(cpoID)
                    .then(result => {
                        dispatch(getCpoItemsSuccess(cpo));
                        dispatch(getCpoHistorySuccess(result));
                    })
                    .catch(error => dispatch(getCpoHistoryFail(error)));
            })
            .catch(error => {
                dispatch(getCpoItemsFail(error));
            });
    };
};

const changePage = (page, format_result = false) => {
    return dispatch => {
        dispatch(changeCPOPage({ page: page }));
        dispatch(getAll(format_result));
    };
};

const getCpoItem = (cpoID, itemID) => {
    return dispatch => {
        dispatch({ type: types.GET_CPO_ITEM });
        service
            .getCpoItem(cpoID, itemID)
            .then(item => {
                dispatch({ type: types.GET_CPO_ITEM_COMMENTS });
                service
                    .getCpoItemComments(cpoID, itemID)
                    .then(comments => {
                        dispatch(getCpoItemSuccess({ item, cpoID, itemID }));
                        dispatch(getCommentsSuccess({ comments, cpoID, itemID }));
                    })
                    .catch(error => getCommentsFail({ error, cpoID, itemID }));
            })
            .catch(error => {
                dispatch(getCpoItemFail({ error, cpoID, itemID }));
            });
    };
};

const cancelCpoItem = (cpoID, itemID) => {
    return dispatch => {
        dispatch({ type: types.CANCEL_CPO_ITEM });
        service
            .cancelCpoItem(cpoID, itemID)
            .then(item => dispatch(cancelCpoItemSuccess({ item, cpoID, itemID })))
            .catch(error => {
                dispatch(cancelCpoItemFail({ error, cpoID, itemID }))
                swal({
                    title: "Error",
                    text: utils.computeError(error),
                    icon: "warning",
                    timer: 5000,
                    button: true
                });
            });
    };
};

const cancelCPO = (cpoID, cpoNumber) => {
    return dispatch => {
        dispatch({ type: types.CANCEL_CPO });
        return service
            .cancelCpo(cpoID, cpoNumber)
            .then(register => {
                swal({ title: "The customer purchase order have been canceled successfully.", icon: "success" }).then(
                    value => {
                        window.location.reload();
                    }
                );
                dispatch(cancelCPOSuccess(register));
                return register;
            })
            .catch(error => {
                dispatch(cancelCPOFail(error));
                swal({
                    title: "Error",
                    text: utils.computeError(error),
                    icon: "warning",
                    timer: 3000,
                    button: true
                });
                return error;
            });
    };
};
const reOpenCPO = cpoID => {
    return dispatch => {
        dispatch({ type: types.RE_OPEN_CPO });
        service
            .reOpenCPO(cpoID)
            .then(response => {
                dispatch({ type: types.RE_OPEN_CPO_END });
                swal({ title: "Re-Open was success", icon: "success", timer: 2000 }).then(value => {
                    window.location.reload();
                });
            })
            .catch(error => {
                dispatch({ type: types.RE_OPEN_CPO_END });
                swal({ title: "Error", text: utils.computeError(error), icon: "warning", timer: 3000, button: true });
            });
    };
};

const updateFilter = (filters, format_result = false) => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeCPOPage({ page: 1 }));
        dispatch(getAll(format_result));
        return Promise.resolve(filters);
    };
};

const newItemComment = comment => {
    return dispatch => {
        const { cpoID, itemID, username, message } = comment;
        dispatch({ type: types.NEW_CPO_ITEM_COMMENT });
        service
            .newCommet(cpoID, itemID, username, message)
            .then(comment => dispatch(newItemCommentSuccess(comment)))
            .catch(error => dispatch(newItemCommentFail(error)));
    };
};

const updateCPO = (cpo_id, circle, project, cpo_effective_to_date, blank_oet_received_date, callbackOk ) => {
    return dispatch => {
        console.log(cpo_effective_to_date)
        dispatch({ type: types.UPDATE_CPO });
        service
            .updateCPO(cpo_id, circle, project, cpo_effective_to_date, blank_oet_received_date)
            .then(cpo_register => dispatch(updateCPOSuccess({ cpo_register }, callbackOk)))
            .catch(error => dispatch(updateCPOFail(error)));
    };
};

const sendFile = data => {
    return dispatch => {
        dispatch({
            type: types.SEND_FILE
        })
        return service.sendFile(data)
            .then(result=> {
                dispatch({
                    type: types.SEND_FILE_SUCCESS
                });
                return result;
            })
            .catch(error=>{
                dispatch({
                    type: types.SEND_FILE_FAIL,
                    payload: error
                });
            });
    };

};

const listCircles = search => {
    return dispatch => {
        dispatch({ type: types.LIST_CIRCLES });
        return service
            .listCircles(search)
            .then(result => {
                const data = result.results.map(circle => ({
                    label: circle.name,
                    value: circle.name
                }));
                dispatch(listCirclesSuccess(data));
                return data;
            })
            .catch(error => {
                const data = error.response;
                dispatch(listCirclesFail(data));
                return data;
            });
    };
};

const listCirclesSuccess = payload => {
    return {
        type: types.LIST_CIRCLES_SUCCESS,
        payload
    };
};

const listCirclesFail = error => {
    return {
        type: types.LIST_CIRCLES_FAIL,
        error
    };
};

const updateCPOSuccess = (payload, cb = () => {}) => {
    cb(payload);
    return {
        type: types.UPDATE_CPO_SUCCESS,
        payload
    };
};

const updateCPOFail = (payload) => {
    swal({ title: "Error", icon: "error", text: utils.computeError(payload) });
    return {
        type: types.UPDATE_CPO_FAIL,
        payload
    }
}
    

const nonOetRelated = (cpoID, cpoNumber, callbackOk = () => {}, callbackFail = () => {}) => {
    return dispatch => {
        dispatch({ type: types.NON_OET_RELATED_CPO });
        service
            .nonOetRelatedCpo(cpoID, cpoNumber)
            .then(cpo => dispatch(nonOetRelatedSuccess(cpo, callbackOk)))
            .catch(err => dispatch(nonOetRelatedFail(err, callbackFail)));
    };
};

const nonOetRelatedSuccess = (payload, callbackOk) => {
    callbackOk(payload);
    return {
        type: types.NON_OET_RELATED_CPO_SUCCESS,
        payload
    };
};

const nonOetRelatedFail = (payload, callbackFail) => {
    callbackFail(payload);
    return {
        type: types.NON_OET_RELATED_CPO_FAIL,
        payload
    };
};

const cleanReportMessages = () => ({
    type: types.REPORT_CLEAN
});

const newItemCommentSuccess = payload => ({
    type: types.NEW_CPO_ITEM_COMMENT_SUCCESS,
    payload
});

const newItemCommentFail = payload => ({
    type: types.NEW_CPO_ITEM_COMMENT_FAIL,
    payload
});

const getCommentsSuccess = payload => ({
    type: types.GET_CPO_ITEM_COMMENTS_SUCCESS,
    payload
});

const getCommentsFail = payload => ({
    type: types.GET_CPO_ITEM_COMMENTS_FAIL,
    payload
});

const getCpoItemSuccess = payload => ({
    type: types.GET_CPO_ITEM_SUCCESS,
    payload
});

const getCpoItemFail = payload => ({
    type: types.GET_CPO_ITEM_FAIL,
    payload
});

const cancelCpoItemSuccess = payload => ({
    type: types.CANCEL_CPO_ITEM_SUCCESS,
    payload
});

const cancelCpoItemFail = payload => ({
    type: types.CANCEL_CPO_ITEM_FAIL,
    payload
});

const cancelCPOSuccess = payload => ({
    type: types.CANCEL_CPO_SUCCESS,
    payload
});

const cancelCPOFail = payload => ({
    type: types.CANCEL_CPO_FAIL,
    payload
});

const getCpoHistorySuccess = payload => ({
    type: types.GET_CPO_HISTORY_SUCCESS,
    payload
});

const getCpoHistoryFail = payload => ({
    type: types.GET_CPO_HISTORY_FAIL,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_All_SUCCESS,
    payload
});

const getAllFail = error => ({
    type: types.GET_All_FAIL,
    payload: error
});

const getCpoItemsSuccess = payload => ({
    type: types.GET_CPO_ITEMS_SUCCESS,
    payload
});

const getCpoItemsFail = payload => ({
    type: types.GET_CPO_ITEMS_FAIL,
    payload
});

const changeCPOPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

export default {
    getAll,
    getCpoItem,
    getCpoItems,
    cancelCpoItem,
    changePage,
    updateFilter,
    cleanReportMessages,
    newItemComment,
    nonOetRelated,
    cancelCPO,
    reOpenCPO,
    updateCPO,
    listCircles,
    sendFile
};
